import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function HomeRedirect() {
    const { isAuthenticated, user, isLoading } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!isLoading) {
            const search = searchParams.toString() ? `?${searchParams.toString()}` : '';
            if (isAuthenticated && (user?.is_vip || user?.usr_admin)) {
                navigate(`/inicio${search}`, { replace: true });
            } else {
                navigate(`/landing${search}`, { replace: true });
            }
        }
    }, [isLoading, isAuthenticated, user, navigate, searchParams]);

    return null;
}
